import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { GlobalStatusService } from '@src/app/services/global-status.service';
import { CommonService } from '@src/app/services/common.service';
import { environment } from '@src/environments/environment';
import { UserService } from '@src/app/services/user.service';
import dayjs from 'dayjs';
import { SharedModule } from '@src/app/shared/shared.module';
import { slideInLeftOnEnterAnimation } from 'angular-animations';
import { TelegramService } from '@src/app/services/telegram.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Component({
    selector: 'app-monad-campaign',
    standalone: true,
    imports: [CommonModule, SharedModule],
    animations: [slideInLeftOnEnterAnimation({ duration: 300 })],
    templateUrl: './monad-campaign.component.html',
    styleUrls: ['./monad-campaign.component.less'],
})
export class MonadCampaignComponent implements OnInit {
    cardCollapsed = true;
    campaignVisible = true;
    campaignID = '2';
    timeLeftNumbers: (string | number)[] = [10, 10, 10, 10];
    eventStats: 'soon' | 'ongoing' | 'expired' = 'soon';
    startDate = dayjs.utc('2025-07-16T12:00:00Z').add(-10, 'days');
    endDate = dayjs.utc('2025-08-25T12:00:00Z');

    get sideBarCollapsed() {
        return this.globalStatusService.sideBarCollapsed$.getValue();
    }

    constructor(
        private globalStatusService: GlobalStatusService,
        public commonService: CommonService,
        public telegramService: TelegramService,
        private userService: UserService,
        private router: Router,
        @Inject(PLATFORM_ID) private platformId: any
    ) {}

    ngOnInit() {
        if (isPlatformBrowser(this.platformId)) {
            this.updateTimeLeft();
            this.setupRouterChangeMonitor();
        }
    }

    joinUs() {
        if (this.userService.isAuthenticated) {
            window.open(`${environment.telegram.botLink}?start=cp_view_${this.userService.getUserID()}_${this.campaignID}`, '_blank');
        } else {
            this.commonService.showLogInModal();
        }
    }

    private updateTimeLeft() {
        const now = dayjs();
        const diff = this.endDate.diff(now);
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);
        this.timeLeftNumbers = [days, hours, minutes, seconds].map(num => (num < 10 ? `0${num}` : num));

        if (this.endDate.isBefore(dayjs())) {
            this.eventStats = 'expired';
        } else if (this.startDate.isBefore(dayjs())) {
            this.eventStats = 'ongoing';
        } else {
            this.eventStats = 'soon';
        }

        if (this.eventStats !== 'ongoing') {
            this.campaignVisible = false;
            this.timeLeftNumbers = ['00', '00', '00', '00'];
        } else {
            setTimeout(() => {
                this.updateTimeLeft();
            }, 1000);
        }
    }

    // 监听路由变化事件，设置对应变量
    private setupRouterChangeMonitor() {
        this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe(event => {
            // If Day Mining Page， collapsed side bar
            if (event?.url.startsWith('/hemera/agent/mining-days')) {
                this.cardCollapsed = false;
            } else {
                this.cardCollapsed = true;
            }
        });
    }
}
